import endpoints from 'api/endpoints';

export default id => ({
  url: endpoints.getSingleBoardUrl(id),
  queryKey: `delete${endpoints.getSingleBoardUrl()}`,
  meta: {
    authToken: true,
  },
  force: true,
  options: {
    headers: {
      Accept: 'application/json',
    },
    method: 'DELETE',
  },
  update: {
    board: prevResult => prevResult.filter(item => item.get('_id') !== id),
  },
  updateResult: {
    boards: prevResult => prevResult.filter(item => item !== id),
  },
});
